import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const duplicateCheckoutWidget = {
  name: "duplicateCheckoutWidget" as const,
  input: z.object({ widgetId: zExt.objectId() }),
  output: z.object({ widgetId: zExt.objectId() }),
};
